import styled from "styled-components";
import { Link } from "react-router-dom";

import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const WineSpecsWrapper = styled.div<{ isWineDetailsPage: boolean }>`
  padding: 0px 15px 32px 15px;
  ${(props) => props.isWineDetailsPage && "padding: 0px 70px 40px 70px;"}

  ${breakpoints.smDown} {
    ${(props) => props.isWineDetailsPage && "padding: 0px 15px 20px 15px;"}
  }
`;

export const WineSpecsTitle = styled.div<{ isWineDetailsPage: boolean }>`
  font-family: ${fonts.fontBauMedium};
  text-transform: uppercase;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;

  ${(props) => props.isWineDetailsPage && "margin-bottom: 24px"};

  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

export const WineSpecsRow = styled.div`
  padding: 8px 4px;
  border-bottom: 1px solid ${colors.silverSoft};
  justify-content: space-between;
  display: flex;
  flex-direction: row;
`;

export const SpecTitle = styled.div`
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  font-size: 11px;
  line-height: 10px;
  letter-spacing: 1.1px;
  align-self: center;
`;

export const SpecValue = styled.div`
  font-family: ${fonts.fontBauRegular};
  font-size: 12px;
  line-height: 17px;
  text-align: right;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: end;
  margin-left: 50px;
`;

export const CollectionLinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CollectionLink = styled(Link)`
  text-decoration: underline;
  &:hover {
    color: ${colors.coral};
  }
`;
